export default __webpack_public_path__ + "static/media/Logo-Full-Light.2252cda2.png";